import { Component, effect, OnInit } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { ButtonComponent } from "../../shared/ui-common/button/button.component";
import { environment } from 'src/environments/environment';
import { VideoBackgroundComponent } from 'src/app/shared/ui-common/video-background/video-background.component';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from 'src/app/shared/data/pipes/translate.pipe';
import { TranslationService } from 'src/app/shared/data/translation.service';
import { SharedService } from 'src/app/shared/data/shared.service';
import { PillService } from 'src/app/shared/data/pill.service';
import { MenuItem } from 'src/app/shared/data/models/menu-item.model';

@Component({
  selector: 'app-feature-explain',
  imports: [
    CommonModule,
    ButtonComponent,
    VideoBackgroundComponent,
    TranslatePipe,
    RouterLink
  ],
  templateUrl: './feature-explain.component.html',
  styleUrl: './feature-explain.component.scss',
})
export class FeatureExplainComponent implements OnInit {

  s3BaseUrl = environment.s3BaseUrl;
  showHowdyVideo = false;
  language = 'English';
  videoFormat = '.mp4';
  selectedMenuItem: MenuItem | null = null;

  get buttonLabel(): string {
    return this.selectedMenuItem?.isAvailable ? 'WebApp.v1.Shared.Buttons.Start' : 'WebApp.v1.Shared.Buttons.SeeStats';
  }

  get buttonIcon(): string {
    return this.selectedMenuItem?.isAvailable ? 'fa-solid fa-brain' : 'fa-solid fa-chart-simple';
  }


  get buttonColor(): string {
    return this.selectedMenuItem?.isAvailable ? '#57DF8E' : '#2DADC8';
  }

  get buttonLink(): string {
    return this.selectedMenuItem?.isAvailable ? '/survey' : '/stats';
  }

  constructor(
    private location: Location,
    private translationService: TranslationService,
    private sharedService: SharedService,
    private pillService: PillService
  ) {
    effect(() => {
      this.selectedMenuItem = this.pillService.getCurrentMenuItem();
    });
  }

  ngOnInit(): void {
    const languageId = this.translationService.getLanguageId();
    this.language = languageId === '1041' ? 'Danish' : 'English';
    this.videoFormat = this.sharedService.getVideoFormat();
  }

  goBack(): void {
    this.location.back();
  }
}
